import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import axios from "axios";
import cookie from "js-cookie";
import { toast } from "react-toastify";
import Loader from "../../../components/shared/Loader";
import { updateMeta } from "../../../store/actions/metaAction";
import userPlaceholder from "../../../assets/images/placeholder.jpg";


const AdvantagesCreate = () => {
	const auth = useSelector(state => state.auth.user);
	const history = useHistory();
	const [title, setTitle] = useState("");
	const [description, setDescription] = useState("");
	const [titleEn, setTitleEn] = useState("");
	const [descriptionEn, setDescriptionEn] = useState("");
	const [loading, setLoading] = useState(false);
	const [picture, setPicture] = useState(null);

	const dispatch = useDispatch();

	useEffect(() => {
		onStart();
	}, []);

	const onStart = () => {
		dispatch(
			updateMeta({
				title: "اضافة ميزه",
				breadcrumb: "المزايا",
				button: {
					show: false,
					text: null,
					link: null,
				},
			})
		);
	};
	const handlePicture = (e) => {
		e.preventDefault();
		const fileInput = document.querySelector("#picture");


		if (fileInput.files[0]) {
			const data = new FormData();
			data.append("file", fileInput.files[0]);
			axios
				.post(`${process.env.REACT_APP_API_URL}/upload`, data, {
					headers: {
						Authorization: `Bearer ${cookie.get("token")}`,
						Accept: "application/json",
						"Content-Type": "multipart/form-data",
					},
				}).then(response => {
					setPicture(response.data.data.name);
					setLoading(false);
					toast.success("تم رفع الصورة بنجاح!");
				}).catch(error => {
					console.log(error);
					toast.error("خطأ في رفع الصورة، برجاء المحاولة مرة أخرى!");
					setLoading(false);
				});
		}
	};
	const handleSubmit = e => {
		e.preventDefault();

		if (!title || !titleEn || !description || !descriptionEn || !picture) {
			return toast.error("جميع البيانات مطلوبة");
		}

		const data = {
			title: {
				ar: title,
				en: titleEn,
			},
			description: {
				ar: description,
				en: descriptionEn,
			},
			image: picture
		};
		axios
			.post(
				`${process.env.REACT_APP_API_URL}/posts`,
				{
					admin_id: auth.id,
					category_id: 21,
					data: data,
				},
				{
					headers: {
						Authorization: `Bearer ${cookie.get("token")}`,
						Accept: "application/json",
					},
				}
			)
			.then(function (response) {
				history.push("/aboutPage/advantages/index");
				toast.success("تم اضافة الميزه بنجاح!");
				setLoading(false);
			})
			.catch(function (error) {
				toast.error("خطأ، برجاء المحاولة مره اخرى!");
				setLoading(false);
			});
	};

	return (
		<section>
			{loading && <Loader />}
			<form onSubmit={handleSubmit}>
				<div className="row">
					<div className="col-md-12">
						<div className="card">
							<div className="card-body">
								<div className="row justify-content-center">
									<div className="col-md-6">
										<div className="form-item">
											<label htmlFor="title">العنوان بالعربي</label>
											<input
												type="text"
												
												id="title"
												onChange={e => setTitle(e.target.value)}
											/>
										</div>
									</div>
									<div className="col-md-6">
										<div className="form-item">
											<label htmlFor="title">العنوان بالانجليزي</label>
											<input
												type="text"
												dir="ltr"
												id="title"
												onChange={e => setTitleEn(e.target.value)}
											/>
										</div>
									</div>
									<div className="col-md-6">
										<div className="form-item">
											<label htmlFor="description">الوصف بالعربي</label>
											<textarea
												id="description"
												cols="30"
												rows="2"
												onChange={e => setDescription(e.target.value)}
											/>
										</div>
									</div>
									<div className="col-md-6">
										<div className="form-item">
											<label htmlFor="description">الوصف بالانجليزي</label>
											<textarea
												id="description"
												cols="30"
												rows="2"
												dir="ltr"
												onChange={e => setDescriptionEn(e.target.value)}
											/>
										</div>
									</div>

									<div className="col-md-12	">
										<div className="form-item col-12 ">
											<label>صورة </label>
											<input type="file" onChange={handlePicture} id="picture" />
											<div className="img-holder">
												<img src={picture ? process.env.REACT_APP_MAIN_URL + picture : userPlaceholder} alt="avatar" className="imagePreview" />
											</div>
										</div>

									</div>

									<div className="col-md-4">
										<div className="form-item mt-3">
											<button className="bt bt-success btn-block">ارسال</button>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</form>
		</section>
	);
};

export default AdvantagesCreate;
